import { render, staticRenderFns } from "./UserEditBrowseList.vue?vue&type=template&id=d4fdb1e6"
import script from "./UserEditBrowseList.vue?vue&type=script&lang=ts"
export * from "./UserEditBrowseList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4fdb1e6')) {
      api.createRecord('d4fdb1e6', component.options)
    } else {
      api.reload('d4fdb1e6', component.options)
    }
    module.hot.accept("./UserEditBrowseList.vue?vue&type=template&id=d4fdb1e6", function () {
      api.rerender('d4fdb1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/UserEditBrowseList.vue"
export default component.exports